import React from "react";
import styled from "styled-components";
// import PropTypes from "prop-types";

// Styles
const Header = styled.h3`
  text-align: left;
`;

// {/* <h3 style={{ textAlign: "left" }}> {title} </h3> */}
const CardHeader = ({ title }) => (
  <React.Fragment>
    <Header> {title} </Header>
    <hr />
  </React.Fragment>
);

// CardHeader.propTypes = {
//   title: PropTypes.string.isRequired
// };

export default CardHeader;



// WEBPACK FOOTER //
// ./src/components/CardHeader/index.js